/* ============================================================
   SYNCROFEM · theme.js — motion + cesta AJAX de Shopify
   ============================================================ */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(pointer: fine)').matches;
  var cfg = window.syncrofem || { strings: {} };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- Utilidades ---------- */
  var toastT;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }
  var moneyFmt = null;
  function money(cents, currency) {
    if (!moneyFmt || moneyFmt.currency !== currency) {
      moneyFmt = { currency: currency, fmt: new Intl.NumberFormat('es-ES', { style: 'currency', currency: currency || 'EUR' }) };
    }
    return moneyFmt.fmt.format(cents / 100);
  }

  /* ---------- Preloader (solo 1ª vez de la sesión) ---------- */
  var loaderEl = $('#loader');
  if (loaderEl) {
    if (document.documentElement.classList.contains('no-loader') || reduce) {
      loaderEl.classList.add('off');
    } else {
      addEventListener('load', function () { setTimeout(function () { loaderEl.classList.add('off'); }, 650); });
      setTimeout(function () { loaderEl.classList.add('off'); }, 2200); // red de seguridad
    }
  }

  /* ---------- Entrada de página (cortina) ----------
     `entering` y `loaded` ya las pone un script en línea del layout, para
     que el hero no espere a este archivo (iba al LCP). Aquí se dejan por
     si el layout cambiara: añadir una clase que ya está no hace nada. */
  document.body.classList.add('entering');
  if (!reduce && sessionStorage.getItem('sf-wipe') === '1') {
    document.body.classList.add('wipe-out');
    setTimeout(function () {
      document.body.classList.remove('wipe-out');
      document.documentElement.classList.remove('wipe-boot');
    }, 600);
  } else {
    document.documentElement.classList.remove('wipe-boot');
  }
  sessionStorage.removeItem('sf-wipe');
  setTimeout(function () { document.body.classList.add('loaded'); }, reduce ? 0 : 150);

  /* Salida con cortina en enlaces internos */
  if (!reduce) {
    var leaving = false;   /* sin esto, dos clics seguidos lanzan dos cortinas */
    document.addEventListener('click', function (e) {
      if (leaving) { e.preventDefault(); return; }
      var a = e.target.closest('a[href]');
      if (!a) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || a.target === '_blank') return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.hash) return;
      e.preventDefault();
      leaving = true;
      sessionStorage.setItem('sf-wipe', '1');
      document.body.classList.add('wipe-in');
      setTimeout(function () { location.href = a.href; }, 400);
    });
  }

  /* ---------- Scroll suave para anclas internas ---------- */
  var glideRaf = null, glideTok = 0;
  function glide(targetY, dur) {
    var tok = ++glideTok;
    cancelAnimationFrame(glideRaf);
    var max = document.documentElement.scrollHeight - innerHeight;
    targetY = Math.max(0, Math.min(targetY, max));
    if (reduce) { scrollTo(0, targetY); return; }
    var from = scrollY, dist = targetY - from;
    if (Math.abs(dist) < 2) return;
    dur = dur || Math.min(1100, 450 + Math.abs(dist) * .12);
    var t0 = performance.now();
    (function step(t) {
      if (tok !== glideTok) return;
      var p = Math.min((t - t0) / dur, 1);
      var e = 1 - Math.pow(1 - p, 3);
      scrollTo(0, from + dist * e);
      if (p < 1) glideRaf = requestAnimationFrame(step);
    })(t0);
    setTimeout(function () { if (tok === glideTok && Math.abs(scrollY - targetY) > 4) scrollTo(0, targetY); }, dur + 180);
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a) return;
    var el = document.querySelector(a.getAttribute('href'));
    if (el) { e.preventDefault(); glide(el.getBoundingClientRect().top + scrollY - 90); }
  });

  /* ---------- Nav ---------- */
  var nav = $('#nav');
  if (nav) addEventListener('scroll', function () { nav.classList.toggle('scrolled', scrollY > 24); }, { passive: true });
  var burger = $('#burger');
  if (burger) burger.addEventListener('click', function () { document.body.classList.toggle('menu-open'); });

  /* ---------- Reveals + observers ---------- */
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); } });
  }, { threshold: .14 });
  $$('.rv').forEach(function (el) { reduce ? el.classList.add('on') : io.observe(el); });
  var io2 = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('on'); io2.unobserve(e.target); } });
  }, { threshold: .3 });
  $$('.wow, .tl').forEach(function (el) { reduce ? el.classList.add('on') : io2.observe(el); });
  var io3 = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return; io3.unobserve(e.target);
      var el = e.target, target = +el.getAttribute('data-count'), pre = el.getAttribute('data-prefix') || '', suf = el.getAttribute('data-suffix') || '';
      var t0 = performance.now();
      (function tick(t) {
        var p = Math.min((t - t0) / 1200, 1);
        el.textContent = pre + Math.round(target * (1 - Math.pow(1 - p, 3))) + suf;
        if (p < 1) requestAnimationFrame(tick);
      })(t0);
      setTimeout(function () { el.textContent = pre + target + suf; }, 1400);
    });
  }, { threshold: .6 });
  $$('[data-count]').forEach(function (el) {
    if (reduce) { el.textContent = (el.getAttribute('data-prefix') || '') + el.getAttribute('data-count') + (el.getAttribute('data-suffix') || ''); }
    else io3.observe(el);
  });

  /* ---------- Cursor propio ---------- */
  if (fine) {
    var dot = document.createElement('div'); dot.className = 'cur-dot';
    var ring = document.createElement('div'); ring.className = 'cur-ring';
    document.body.appendChild(dot); document.body.appendChild(ring);
    var mx = -100, my = -100, rx = -100, ry = -100;
    addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate(' + (mx - 4) + 'px,' + (my - 4) + 'px)';
    }, { passive: true });
    (function ringLoop() {
      rx += (mx - rx) * .16; ry += (my - ry) * .16;
      ring.style.transform = 'translate(' + (rx - ring.offsetWidth / 2) + 'px,' + (ry - ring.offsetHeight / 2) + 'px)';
      requestAnimationFrame(ringLoop);
    })();
    document.addEventListener('mouseover', function (e) {
      document.body.classList.toggle('cur-hover', !!e.target.closest('a, button, summary, .opt, .phase-chip, input, select'));
    }, { passive: true });
  }

  /* ---------- Magnetismo + tilt ---------- */
  if (fine && !reduce) {
    $$('.btn').forEach(function (b) {
      b.addEventListener('mousemove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * .18) + 'px,' + ((e.clientY - r.top - r.height / 2) * .3) + 'px)';
      });
      b.addEventListener('mouseleave', function () { b.style.transform = ''; });
    });
    $$('.tilt').forEach(function (s) {
      s.addEventListener('mousemove', function (e) {
        var r = s.getBoundingClientRect();
        var dx = (e.clientX - r.left) / r.width - .5, dy = (e.clientY - r.top) / r.height - .5;
        s.style.transform = 'perspective(1000px) rotateX(' + (-dy * 6).toFixed(2) + 'deg) rotateY(' + (dx * 8).toFixed(2) + 'deg)';
      });
      s.addEventListener('mouseleave', function () { s.style.transform = ''; });
    });
  }

  /* ---------- Parallax pétalos hero ---------- */
  if (!reduce && fine) {
    var pets = $$('.hp');
    if (pets.length) {
      var pRaf = null;
      addEventListener('mousemove', function (e) {
        var pmx = e.clientX / innerWidth - .5, pmy = e.clientY / innerHeight - .5;
        if (!pRaf) pRaf = requestAnimationFrame(function () {
          pets.forEach(function (p) {
            var d = parseFloat(p.getAttribute('data-depth')) * 200;
            p.style.transform = 'translate(' + (pmx * d) + 'px,' + (pmy * d) + 'px)';
          });
          pRaf = null;
        });
      }, { passive: true });
    }
  }

  /* ---------- Marquesina ---------- */
  $$('.claims .mq-track').forEach(function (track) {
    var one = track.innerHTML;
    track.innerHTML = one + one + one + one;
    if (reduce) track.style.animation = 'none';
  });

  /* ---------- Manifiesto palabra a palabra ---------- */
  var manifH = $('.darksec h2[data-words]');
  var manifWords = [];
  if (manifH) {
    manifH.innerHTML = manifH.textContent.trim().split(/\s+/).map(function (w) { return '<span class="wd">' + w + '</span>'; }).join(' ');
    manifWords = $$('.wd', manifH);
    if (reduce) manifWords.forEach(function (w) { w.classList.add('lit'); });
  }

  /* ---------- Efectos de scroll ---------- */
  var heroWrap = $('.hero-home .wrap');
  var progress = $('#progress');
  function onScrollFx() {
    var max = document.documentElement.scrollHeight - innerHeight;
    if (progress) progress.style.width = (max > 0 ? (scrollY / max) * 100 : 0) + '%';
    if (reduce) return;
    if (heroWrap && scrollY < innerHeight * 1.2) {
      heroWrap.style.transform = 'translateY(' + (scrollY * .28).toFixed(1) + 'px)';
      heroWrap.style.opacity = Math.max(0, 1 - scrollY / (innerHeight * .85)).toFixed(3);
    }
    if (manifWords.length) {
      var r = manifH.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) {
        var p = Math.max(0, Math.min(1, (innerHeight * .85 - r.top) / (innerHeight * .55)));
        var lit = Math.round(p * manifWords.length);
        manifWords.forEach(function (w, i) { w.classList.toggle('lit', i < lit); });
      }
    }
  }
  addEventListener('scroll', onScrollFx, { passive: true });
  onScrollFx();

  /* ============================================================
     CESTA · Shopify AJAX Cart API
     ============================================================ */
  /* El cajón es un diálogo: mientras está abierto, el teclado no debe
     tabular a la página de detrás. Se recuerda desde dónde se abrió para
     devolver el foco al cerrarlo. */
  var cartOpener = null;

  function cartFocusables() {
    return $$('#cart a[href], #cart button:not([disabled]), #cart [tabindex]:not([tabindex="-1"])')
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function trapCartFocus(e) {
    if (e.key !== 'Tab' || !document.body.classList.contains('cart-open')) return;
    var f = cartFocusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!$('#cart').contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  }

  function openCart() {
    cartOpener = document.activeElement;
    document.body.classList.add('cart-open');
    refreshCart();
    var c = $('#cart');
    if (c) { c.setAttribute('role', 'dialog'); c.setAttribute('aria-modal', 'true'); }
    addEventListener('keydown', trapCartFocus);
    setTimeout(function () { var cl = $('#cartClose'); if (cl) cl.focus(); }, 60);
  }

  function closeCart() {
    if (!document.body.classList.contains('cart-open')) return;
    document.body.classList.remove('cart-open');
    removeEventListener('keydown', trapCartFocus);
    if (cartOpener && cartOpener.focus) cartOpener.focus();
    cartOpener = null;
  }
  var cartBtn = $('#cartBtn');
  if (cartBtn) cartBtn.addEventListener('click', openCart);
  var cartClose = $('#cartClose');
  if (cartClose) cartClose.addEventListener('click', closeCart);
  var scrim = $('#scrim');
  if (scrim) scrim.addEventListener('click', closeCart);
  addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); document.body.classList.remove('menu-open'); } });

  function bumpCount(n) {
    var c = $('#cartCount'); if (!c) return;
    c.textContent = n;
    if (cartBtn) { cartBtn.classList.remove('bump'); void cartBtn.offsetWidth; cartBtn.classList.add('bump'); }
  }

  /* Cambiar una línea de la cesta. El servidor tarda, así que la pantalla
     responde antes: se pinta la cantidad nueva y se bloquea la fila. Sin
     esto, en conexión lenta el botón parece muerto y se pulsa tres veces. */
  function changeLine(key, quantity, row) {
    if (row) row.classList.add('is-busy');
    return fetch(cfg.cartChangeUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {
        if (row) row.classList.remove('is-busy');
        toast(cfg.strings.cartError || 'No se pudo actualizar la cesta');
      });
  }

  function bindCartControls() {
    $$('#cartBody [data-q]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.citem');
        if (row.classList.contains('is-busy')) return;
        var qtyEl = row.querySelector('.qty span');
        var q = Math.max(0, parseInt(qtyEl.textContent, 10) + parseInt(b.getAttribute('data-q'), 10));
        qtyEl.textContent = q;                    /* respuesta inmediata */
        changeLine(row.getAttribute('data-key'), q, row);
      });
    });
    $$('#cartBody [data-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        var row = b.closest('.citem');
        if (row.classList.contains('is-busy')) return;
        row.classList.add('is-going');
        changeLine(row.getAttribute('data-key'), 0, row);
      });
    });
  }

  function renderCart(cart) {
    var body = $('#cartBody'); if (!body) return;
    bumpCount(cart.item_count);
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><div class="big">🌸</div>' +
        (cfg.strings.cartEmpty || 'Tu cesta está vacía.') +
        (cfg.strings.cartEmptyNote ? '<br>' + cfg.strings.cartEmptyNote : '') + '</div>';
    } else {
      var note = document.querySelector('#cart .citem .pl');
      var itemNote = note ? note.getAttribute('data-note') || '' : '';
      body.innerHTML = cart.items.map(function (it) {
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_150x$1$2') + '" alt="" loading="lazy">'
          : '<svg viewBox="0 0 340 400"><use href="#sf-bottle"/></svg>';
        var plan = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : (it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : itemNote);
        return '<div class="citem" data-key="' + it.key + '">' +
          '<div class="thumb">' + img + '</div>' +
          '<div><div class="tt">' + it.product_title + '</div>' +
          '<div class="pl" data-note="' + itemNote.replace(/"/g, '&quot;') + '">' + (plan || '') + '</div>' +
          '<span class="qty">' +
          '<button data-q="-1" aria-label="' + (cfg.strings.cartLess || 'Quitar una unidad') + '">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button data-q="1" aria-label="' + (cfg.strings.cartMore || 'Añadir una unidad') + '">+</button>' +
          '</span></div>' +
          '<div class="pr">' + money(it.final_line_price, cart.currency) +
          '<button class="citem-x" data-remove aria-label="' + (cfg.strings.cartRemove || 'Eliminar') + '">' + (cfg.strings.cartRemove || 'Eliminar') + '</button>' +
          '</div></div>';
      }).join('');
      bindCartControls();
    }
    var tot = $('#cartTotal');
    if (tot) tot.textContent = money(cart.total_price, cart.currency);
  }
  function refreshCart() {
    fetch(cfg.cartUrl + '.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  /* Los controles de la primera carga vienen de Liquid, no de renderCart(),
     así que también hay que engancharlos. */
  bindCartControls();

  /* Añadir a la cesta: formularios de producto */
  $$('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('disabled', '');
      fetch(cfg.cartAddUrl + '.js', { method: 'POST', body: fd })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function () { toast(cfg.strings.added || 'Añadido'); openCart(); })
        .catch(function () { toast(cfg.strings.cartError || 'Error'); })
        .finally(function () { if (btn) btn.removeAttribute('disabled'); });
    });
  });

  /* Selector suscripción / compra única (ficha de producto) */
  $$('.opts').forEach(function (group) {
    var form = document.querySelector('form[data-product-form]');
    var planInput = form ? form.querySelector('[name="selling_plan"]') : null;
    var priceOut = $('#addPrice');
    $$('.opt', group).forEach(function (o) {
      o.addEventListener('click', function () {
        $$('.opt', group).forEach(function (x) { x.setAttribute('aria-pressed', String(x === o)); });
        if (planInput) planInput.value = o.getAttribute('data-plan-id') || '';
        if (priceOut) priceOut.textContent = o.getAttribute('data-price-label') || '';
      });
    });
  });

  /* Cantidad en ficha de producto */
  $$('.qtyrow .qty').forEach(function (q) {
    var out = q.querySelector('span');
    var input = document.querySelector('form[data-product-form] [name="quantity"]');
    $$('button', q).forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, parseInt(out.textContent, 10) + parseInt(b.getAttribute('data-q'), 10));
        out.textContent = v;
        if (input) input.value = v;
      });
    });
  });

  /* CTA final del producto: envía el formulario principal */
  $$('[data-add-main]').forEach(function (b) {
    b.addEventListener('click', function () {
      var form = document.querySelector('form[data-product-form]');
      if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  });

  /* ---------- Tarjeta flotante de temas (sigue el cursor) ---------- */
  var topics = $('#topics');
  var peek = $('#topicPeek');
  if (topics && peek && fine && !reduce) {
    var peekLabel = peek.querySelector('.pk-label');
    var peekRaf = null, ppx = 0, ppy = 0;
    document.addEventListener('mousemove', function (e) {
      var link = e.target.closest ? e.target.closest('.topic-link') : null;
      if (link && topics.contains(link)) {
        ppx = e.clientX + 26; ppy = e.clientY - 10;
        if (!peekRaf) peekRaf = requestAnimationFrame(function () {
          peek.style.left = ppx + 'px'; peek.style.top = ppy + 'px'; peekRaf = null;
        });
        var acc = link.style.getPropertyValue('--accent') || '#F15A2C';
        peek.style.background = 'linear-gradient(140deg, ' + acc + ', ' + acc + 'cc)';
        peekLabel.textContent = link.getAttribute('data-peek') || '';
        peek.classList.add('on');
      } else {
        peek.classList.remove('on');
      }
    }, { passive: true });
  }

  /* ---------- Scroll-scrubbed: ritual, timeline, testimonios ---------- */
  function scrubFx() {
    if (reduce) return;
    function prog(el, a, b) { var r = el.getBoundingClientRect(); var s = innerHeight * a, e = innerHeight * b; return Math.max(0, Math.min(1, (s - r.top) / (s - e))); }
    var grid = $('#ritualGrid');
    if (grid) {
      var p = prog(grid, 0.78, 0.4);
      var liquid = grid.querySelector('#rLiquid'), surf = grid.querySelector('#rSurface');
      var grains = grid.querySelector('#rGrains'), scoop = grid.querySelector('#rScoop');
      var topY = 292 - p * 240;
      if (liquid) { liquid.setAttribute('y', topY.toFixed(1)); liquid.setAttribute('height', (292 - topY).toFixed(1)); }
      if (surf) { surf.setAttribute('cy', topY.toFixed(1)); surf.setAttribute('rx', (33 + p * 19).toFixed(1)); surf.setAttribute('opacity', p > 0.02 ? '.9' : '0'); }
      if (grains) grains.setAttribute('opacity', Math.max(0, 1 - (p - 0.2) / 0.5).toFixed(2));
      if (scoop) { scoop.setAttribute('transform', 'translate(0,' + (-6 + p * 22).toFixed(1) + ')'); scoop.setAttribute('opacity', Math.max(0, 1 - p * 2.2).toFixed(2)); }
      var th = [0.06, 0.42, 0.78];
      $$('.rstep', grid).forEach(function (s, i) { s.classList.toggle('active', p >= th[i]); });
    }
    var track = $('.tl-track');
    if (track) {
      var p2 = prog(track, 0.85, 0.45);
      var f2 = track.querySelector('.tl-line i'), m2 = track.querySelector('.tl-marker');
      /* En móvil la línea es vertical y crece en alto, no en ancho: se
         publica el progreso como variable para que lo use el CSS. */
      track.style.setProperty('--tlp', p2.toFixed(3));
      if (f2) f2.style.width = (p2 * 100) + '%';
      if (m2) m2.style.left = (p2 * 100) + '%';
      var items = $$('.tl-item', track);
      items.forEach(function (it, i) { it.classList.toggle('active', p2 >= i / items.length + 0.03); });
    }
    var rev = $('.reviews');
    if (rev) {
      var qm = rev.querySelector('.quote-mark');
      if (qm) { var r3 = rev.getBoundingClientRect(); qm.style.transform = 'translateY(' + (r3.top * -0.1).toFixed(1) + 'px)'; }
    }
  }
  addEventListener('scroll', scrubFx, { passive: true });
  scrubFx();

  if (fine && !reduce) {
    $$('.quote').forEach(function (q) {
      q.addEventListener('mousemove', function (e) {
        var r = q.getBoundingClientRect();
        var dx = (e.clientX - r.left) / r.width - .5, dy = (e.clientY - r.top) / r.height - .5;
        q.style.transform = 'perspective(800px) rotateX(' + (-dy * 5).toFixed(2) + 'deg) rotateY(' + (dx * 6).toFixed(2) + 'deg) translateY(-4px)';
      });
      q.addEventListener('mouseleave', function () { q.style.transform = ''; });
    });
  }

  /* ---------- Bote 3D: giro 360º arrastrable con inercia ---------- */
  var spin = $('#wowSpin');
  if (spin) {
    var sLbl = spin.querySelector('#wowLabel');
    var sGloss = spin.querySelector('#wowGloss');
    var sShade = spin.querySelector('#wowShade');
    var S_CX = 170;
    var sAng = 0, sVel = 0, sDrag = false, sLastX = 0, sAuto = !reduce;
    function renderSpin() {
      var a = sAng * Math.PI / 180;
      var c = Math.cos(a);
      var sx = Math.max(0.12, c > 0 ? c : 0.12);
      var x = Math.sin(a) * 118;
      sLbl.setAttribute('transform', 'translate(' + (x + S_CX * (1 - sx)).toFixed(2) + ',0) scale(' + sx.toFixed(3) + ',1)');
      sLbl.setAttribute('opacity', c > 0.05 ? Math.min(1, c * 1.35).toFixed(2) : '0');
      sGloss.setAttribute('x', (60 + Math.sin(a + 0.9) * 68).toFixed(1));
      sShade.setAttribute('x', (250 - Math.sin(a + 0.9) * 58).toFixed(1));
    }
    function spinTick() {
      if (!sDrag) {
        if (sAuto) { sAng -= 0.22; renderSpin(); }
        else if (Math.abs(sVel) > 0.05) { sAng += sVel; sVel *= 0.94; renderSpin(); }
      }
      requestAnimationFrame(spinTick);
    }
    spin.addEventListener('pointerdown', function (e) {
      sDrag = true; sAuto = false; sLastX = e.clientX; sVel = 0;
      try { spin.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });
    spin.addEventListener('pointermove', function (e) {
      if (!sDrag) return;
      var dx = e.clientX - sLastX; sLastX = e.clientX;
      sVel = dx * 0.55; sAng += dx * 0.55; renderSpin();
    });
    addEventListener('pointerup', function () { sDrag = false; });
    renderSpin();
    if (!reduce) requestAnimationFrame(spinTick);
  }

  /* ---------- Newsletter: validación ligera ---------- */
  $$('form.newsform').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var input = f.querySelector('input[type="email"]');
      if (input && !/.+@.+\..+/.test(input.value)) {
        e.preventDefault();
        toast(cfg.strings.emailInvalid || 'Email no válido');
        input.focus();
      }
    });
  });
})();
